<template >
<div>
  <div v-show="issues.length == 0">
    <div class="col-md-12" style="padding-top:30vh;">
      <div class="loader_page"></div>
    </div>
  </div>
  <div v-show="issues.length != 0">
    <div class="row label-zl">
      <div class="start">
        <img src="../assets/label.png" class>
      </div>
      <div class="md10">
        <h5>Lista awarii:</h5>
      </div>
      <div class="end">
        <img src="../assets/end.png" class>
      </div>
    </div>
    <div class="card mb-2">
      <div class="card-body">

        <div>
          <div class="row">
            <div class="col-md-4 col-xs-3">
              <label>Rodzaj awarii:</label>
              <select class="form-control input-sm" style="height:calc(1.7rem + 2px);" v-model="filter">
                <option value="">Wszystkie</option>
                <option value="simple">Zwykłe</option>
                <option value="major">Średnie</option>
                <option value="critical">Krytyczne</option>

              </select>
            </div>
            <div class="col-md-8 col-xs-8">
              <label>Nazwa drużyny:</label>
              <input type="text" v-model="search" class="form-control " style="height:calc(1.7rem + 2px);font-size:13px" placeholder="Wpisz nazwę drużyny którą szukasz...">
            </div>

          </div>
        </div>
        <hr>
        <div class="overflow">
          <table class="tbl-header">
            <thead>
              <tr>
                <th style="width:5%">Nr</th>
                <th style="width:8%">Awatar</th>
                <th style="width:9%">Nazwa</th>
                <th style="width:12%">Data dodania</th>
                <th style="width:12%">Data aktualizacji</th>
                <th>Opis</th>
                <th style="width:10%">Operacje</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in paginatedData" :key="index">
                <td>{{index + 1}}</td>
                <td>
                  <clazy-load v-bind:src="url + item.team.icon" class="card-img-top">
                    <img v-bind:src="url + item.team.icon" class="card-img-top" style="max-width:30px">
                    <div class="preloader" slot="placeholder">
                      <img src="../assets/missingImage.png" />
                    </div>
                  </clazy-load>
                </td>
                <td>{{item.team.name}}</td>
                <td v-b-tooltip.hover :title="item.createdAt | formatDate">{{item.createdAt | ago}}</td>
                <td v-b-tooltip.hover :title="item.updatedAt | formatDate">{{item.updatedAt | ago}}</td>
                <td>{{item.text}}</td>
                <td>
                  <a v-b-tooltip.hover title="Pokaż komentarze" @click="show('comments', item)"> <span class="ti ti-search"></span></a>
                  <a v-b-tooltip.hover title="Pokaż aktualną lokalizację" @click="show('gps', item)">
                    <span class="ti ti-map" style="margin-left:10px"> </span>
                  </a>
                  <a v-b-tooltip.hover title="Pokaż zdjęcia" @click="show('gallery',item.media)">
                    <span class="ti ti-instagram" style="margin-left:10px"> </span>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row" v-show="!(issues.length == 0)" style="margin-top:10px">
          <div class="col-md-9">
            <p style="margin-bottom:0">Ilość: {{issues.length}}</p>
          </div>

          <div class="col-md-3">
            <ul class="pagination pagination-sm" v-show="search == '' && filter == '' " style="margin-bottom:0">
              <li class="page-item" @click="prevPage" :disabled="pageNumber == 0" v-show="pageNumber != 0"><a class="page-link">Wróć</a></li>
              <li class="page-item" v-show="pageNumber == 1" @click="pageNumber =0"><a class="page-link">1</a></li>

              <li class="page-item" v-show="pageNumber > 1" @click="pageNumber-=1"><a class="page-link">{{pageNumber}}</a></li>

              <li class="page-item active"><a class="page-link">{{pageNumber + 1}}</a></li>
              <li class="page-item" v-show="pageNumber != lastItem" @click="pageNumber+=1"><a class="page-link">{{pageNumber + 2}}</a></li>


              <li class="page-item" v-show="lastItem != pageNumber" @click="nextPage"><a class="page-link">Dalej</a></li>

            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <modal name="comments">
    <div v-show="info.comments == '' " style="text-align:center;padding-top:60px;padding-bottom:30px">
      
      <h4 style="padding-top:20px">Brak dostępnych komentarzy!</h4>
    </div>
    <div class="inbox_chat" v-show="info.comments != ''">
      <div class="chat_list" v-for="(item,index) in info.comments" :key="index">
        <div class="chat_people">

          <div class="chat_img"> <img :src="info.team.img" alt="sunil"> </div>
          <div class="chat_ib">
            <h5>{{item.team.name}} <span class="chat_date" v-b-tooltip.hover :title="item.date | formatDate">{{item.date | ago}}</span></h5>
            <p>{{item.text}}</p>
          </div>
        </div>
      </div>
    </div>

  </modal>
  <modal name="gps">
    <GmapMap :center="info.gps" :zoom="14" map-type-id="terrain" style="width: 100%; height: 100%">
      <GmapMarker :position="info.gps" :clickable="true" :draggable="true" />

    </GmapMap>
  </modal>
  <modal name="gallery" :scrollable="true" :adaptive="true" :height="'auto'">
    <div v-if="info.length == 0 " style="text-align:center;padding-top:30px;padding-bottom:30px">
      
      <h4 style="padding-top:20px">Brak dostępnych zdjęć!</h4>
    </div>
    <div v-if="info.length != 0">
      <clazy-load :src="media + item + '.jpg'" class="card-img-top" v-for="(item, index) in info" :key="index">
        <img :src="media + item + '.jpg'" class="card-img-top" style="border-radius:0;">
        <div class="preloader" slot="placeholder" style="padding-top:25px">
          <div class="loader" style="margin-left:auto;margin-right:auto;"></div>
        </div>
      </clazy-load>
    </div>
  </modal>
</div>
</template>

<script>
import api from '../http/api.js'
import config from '../config.json'

export default {
  data() {
    return {
      media: config.media,
      issues: [],
      info: [],
      searchBox: true,
      pageNumber: 0,
      search: "",
      filter: "",
      lastItem: "",
      secondLast: "",
      url: config.media,

    }
  },
  props: {
    listData: {
      type: Array,
      required: false
    },
    size: {
      type: Number,
      required: false,
      default: 10
    }
  },
  computed: {
    pageCount() {

      let l = this.issues.length,
        s = this.size;
      return Math.floor(l / s);
    },
    paginatedData() {
      var vm = this
      const start = this.pageNumber * this.size,
        end = start + this.size;

      vm.secondLast = (Math.round((this.issues.length / 10), 0) - 1)
      vm.lastItem = Math.round((this.issues.length / 10), 0)
      if (this.search == "" && this.filter == "") {
        return this.issues
          .slice(start, end);
      } else if (this.search != "" && this.filter == "") {
        return this.issues.filter(function(item) {
          if (item.team.name.toLowerCase().match(vm.search.toLowerCase()))
            return item
        })
      } else if (this.search == "" && this.filter != "") {
        return this.issues.filter(function(item) {
          if (item.type.toLowerCase().match(vm.filter.toLowerCase()))
            return item
        })
      } else if (this.search != "" && this.filter != "") {
        return this.issues.filter(function(item) {
          if (item.type.toLowerCase().match(vm.filter.toLowerCase()) && item.team.name.toLowerCase().match(vm.search.toLowerCase()))
            return item
        })
      }
    }
  },
  methods: {
    viewSearch() {
      if (this.searchBox)
        this.searchBox = false
      else {
        this.search = ""
        this.filter = ""
        this.searchBox = true
      }
    },
    show(el, data) {
      this.info = []
      this.info = data
      switch (el) {
        case 'comments':
          this.$modal.show('comments');
          break;
        case 'gps':
          this.$modal.show('gps');
          break;
        case 'gallery':
          this.$modal.show('gallery');
          break;

      }
    },
    hide(el) {
      switch (el) {
        case 'comments':
          this.$modal.hide('comments');
          break;
        case 'gps':
          this.$modal.hide('gps');
          break;
        case 'gallery':
          this.$modal.hide('gallery');
          break;

      }
    },
    nextPage() {
      this.pageNumber++;
    },
    prevPage() {
      this.pageNumber--;
    },
    getIssues() {
      var vm = this
      api.getIssuesAction()
        .then(function(res) {
          vm.issues = res.data
        })
        .catch(error => {
          vm.$swal('Ups... coś poszło nie tak',
            `${error}`,
            'warning'
          )
        })
    }
  },
  mounted() {
    this.getIssues()
  }
}
</script>

<style lang="css">
</style>
